import React from 'react';
import {useFragment} from "react-relay";
import graphql from "babel-plugin-relay/macro";
import {useUser} from "../../../hooks/useUser";
import {useTableModals} from "../../../hooks/useTableModals";
import AdvanceTableWrapper from "../../../components/common/advance-table/AdvanceTableWrapper";
import {Card} from "react-bootstrap";
import CardTableHeader from "../../../components/common/headers/CardTableHeader";
import AdvanceTable from "../../../components/common/advance-table/AdvanceTable";
import AdvanceTablePagination from "../../../components/common/advance-table/AdvanceTablePagination";
import {DateCell} from "../../../components/common/advance-table/CustomCells";
import NewPractitionerLocationPracticePeriodModal from "./NewPractitionerLocationPracticePeriodModal";
import DeleteModal from "../../../components/common/modals/DeleteModal";
import EditPractitionerLocationPracticePeriodModal from "./EditPractitionerLocationPracticePeriodModal";

const cols = [
    {accessor: 'effectiveFrom', Header: "Effective From", Cell: DateCell},
    {accessor:'effectiveTo', Header:'Effective To', Cell: DateCell}
]
const PractitionerLocationPracticePeriods = ({practitionerLocationId, practicePeriods}) => {
    const deleteMutation = graphql`
    mutation PractitionerLocationPracticePeriodsDeleteMutation($id:ID!) {
        deleteNode(input: {id: $id}) {
            deletedNodeId @deleteRecord
            owner {
                ... on PractitionerLocation {
                    id
                    practicePeriods {
                        id
                    }}}}}`
    const data = useFragment(graphql`
        fragment PractitionerLocationPracticePeriods_PracticePeriod on PractitionerLocationPracticePeriod @relay(plural: true) {
            id
            effectiveFrom
            effectiveTo
        }
    `, practicePeriods)
    const {hasPermission} = useUser();
    const {selected, columns, newModal, editModal, deleteModal} = useTableModals(cols, "PractitionerLocation.Update", "PractitionerLocation.Update");
    return (
        <>
            <AdvanceTableWrapper columns={columns}
                                 data={data}
                                 sortable
                                 pagination
                                 perPage={10}
            >
                <Card className={"mb-3"}>
                    <Card.Header>
                        <CardTableHeader onNewClick={newModal.onClick}
                                         title={"Practice Periods"}
                                         table
                                         showNew={hasPermission("PractitionerLocation.Update")} />
                    </Card.Header>
                    <Card.Body className={"p-0"}>
                        <AdvanceTable table
                                      headerClassName={"bg-200 text-900 text-nowrap align-middle"}
                                      rowClassName={"align-middle white-space-nowrap"}
                                      tableProps={{size: "sm", striped: true, className: "fs--1 mb-0 overflow-hidden"}}
                        />
                    </Card.Body>
                    <Card.Footer>
                        <AdvanceTablePagination table />
                    </Card.Footer>
                </Card>
            </AdvanceTableWrapper>
            <NewPractitionerLocationPracticePeriodModal showModal={newModal.showModal} 
                                                  onClose={newModal.onClose}
                                                  practitionerLocationId={practitionerLocationId}
            />
            {selected && <EditPractitionerLocationPracticePeriodModal showModal={editModal.showModal}
                                                                onClose={editModal.onClose}
                                                                selectedPracticePeriod={selected}
            />}
            {selected && <DeleteModal mutation={deleteMutation} 
                                      onClose={deleteModal.onClose} 
                                      thingToDelete={"Provider Location's Practice Period"}
                                      showModal={deleteModal.showModal}
                                      id={selected.id}
            >
            <p>This cannot be undone.</p>
            </DeleteModal>}
        </>
    )
}
export default PractitionerLocationPracticePeriods
